/* eslint-disable*/

import * as React from 'react';
import PropTypes from 'prop-types';

import { useSelector } from 'react-redux';
import { useRouter } from 'next/router';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from '@fortawesome/free-solid-svg-icons';
import style from './index.module.css';
import Loader from '../Loader';
import {
  housingOffersSelector,
  loadingSelector,
} from '../../../store/market/selectors';
import useResize from '../../../utils/hooks/useResize';

import DesktopComponent from '../Cards/desktopUi/scoreItems';
import MobileComponent from '../Cards/mobileUi/scoreItems';

const Vivawest = ({ newScore, viva }) => {
  const offers = useSelector(housingOffersSelector);
  const loading = useSelector(loadingSelector);
  const router = useRouter();
  const screenWidth = useResize();

  const redirectToDetailView = React.useCallback((id) => {
    router.push(`/objektdetails/${id}`);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // Todo?: I think newScore isn't working properly right now. Also some minor style problems.
  // Check: https://iib.atlassian.net/browse/RED-3

  return (
    <>
      {offers?.items?.length && newScore ? (
        <>
          {loading ? (
            <Loader />
          ) : (
            <div className={style.container}>
              <main className={style.cards}>
                {offers.items.map((item, idx) => (
                  <div className={style.cards__container} key={item.id}>
                    <article
                      role="presentation"
                      className={style['cards__container--inner']}
                    >
                      <Image
                        images={item.images[0]}
                        redirectToDetailView={redirectToDetailView}
                        item={item}
                      />
                      <section className={style.cards__details}>
                        <Header
                          item={item}
                          redirectToDetailView={redirectToDetailView}
                        />
                        <RentDetails item={item} />
                        {screenWidth > 770 ? (
                          <DesktopComponent
                            newScore={newScore[idx]}
                            item={item}
                            redirectToDetailView={() =>
                              redirectToDetailView(idx)
                            }
                            viva={viva}
                          />
                        ) : (
                          <MobileComponent
                            newScore={newScore[idx]}
                            item={item}
                            redirectToDetailView={() =>
                              redirectToDetailView(idx)
                            }
                            viva={viva}
                          />
                        )}
                      </section>
                    </article>
                  </div>
                ))}
              </main>
            </div>
          )}
        </>
      ) : (
        <p>not found</p>
      )}
    </>
  );
};

export default Vivawest;

export const Header = ({ item, redirectToDetailView }) => (
  <div className={style.cards__header}>
    <header
      className={style['cards__header--title']}
      onClick={() => redirectToDetailView(item.id)}
      role="link"
      tabIndex={0}
      onKeyDown={(e) => e.key === 'Enter' && redirectToDetailView(item.id)}
    >
      <span>
        {item.street && item.houseNumber
          ? `${item.street} ${item.houseNumber}`
          : `${item.city} - ${item.district}`}
      </span>
      <br />
      <span>{`${item.zipCode} ${item.city}`}</span>
      <br />
      <span>{`Gesamtmiete: ${item.warmRent && item.warmRent}€`}</span>
    </header>
    <div className={style['cards__header--icon']}>
      <div className={style['cards__header--icon-container']}>
        <FontAwesomeIcon icon={faStar} size="lg" />
      </div>
      <div>Merken</div>
    </div>
  </div>
);

export const Image = ({ images, redirectToDetailView, item }) => (
  <div
    className={style['cards__img--container']}
    onClick={() => redirectToDetailView(item.id)}
    onKeyDown={(e) => e.key === 'Enter' && redirectToDetailView(item.id)}
    role="link"
    tabIndex={0}
  >
    <img src={images} className={style.cards__img} alt="house" />
    <div className={style['cards__img--container-icon']}>
      <FontAwesomeIcon icon={faStar} size="lg" />
    </div>
  </div>
);

export const RentDetails = ({ item }) => (
  <div className={style['cards__rent-size-room']}>
    <p>
      <strong className={style['cards__rent-size-room--strong']}>
        {item.netRent}
        ,00 €
      </strong>
      <br />
      <span className={style['cards__rent-size-room--span']}>Kaltmiete</span>
    </p>
    <p>
      <strong className={style['cards__rent-size-room--strong']}>
        {item.livingSpace} m²
      </strong>
      <br />
      <span className={style['cards__rent-size-room--span']}>Wohnfläche</span>
    </p>
    <p>
      <strong className={style['cards__rent-size-room--strong']}>
        {item.numberOfRooms}
      </strong>
      <br />
      <span className={style['cards__rent-size-room--span']}>Zimmer</span>
    </p>
  </div>
);

Vivawest.propTypes = {
  newScore: PropTypes.array,
  viva: PropTypes.number,
};

Vivawest.defaultProps = {
  newScore: [],
  viva: 2,
};

Header.propTypes = {
  item: PropTypes.object,
  redirectToDetailView: PropTypes.func,
};

Header.defaultProps = {
  item: {},
  redirectToDetailView: () => '',
};

Image.propTypes = {
  images: PropTypes.string,
  redirectToDetailView: PropTypes.func,
  item: PropTypes.object,
};

Image.defaultProps = {
  images: '',
  redirectToDetailView: () => '',
  item: {},
};

RentDetails.propTypes = {
  item: PropTypes.object,
};

RentDetails.defaultProps = {
  item: {},
};
